export default __webpack_public_path__ + "static/media/hotel.5e8024e7.jpg";